import { createPortal } from "react-dom";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";
import { twMerge } from "tailwind-merge";
export default function Loader({
  open = false,
  type = "default",
  className = "",
  loaderClassName = "",
  message = "",
  position = "normal"
}) {
  const { dir } = useAppSelector(getSettings);

  const loadingContent = open ? (
    <div
      className={twMerge(
        "top-0 ltr:left-0 rtl:right-0 z-20 flex items-center justify-center",
        type === "default"
          ? "fixed  bg-slate-600 bg-opacity-80 h-screen w-screen "
          : "bg-white bg-opacity-70 absolute h-full w-full ",
        className
      )}
      dir={dir}
    >
      <div className="flex items-center justify-center flex-col gap-8">
        <span
          className={twMerge(
            "loader",
            type === "block" ? "!border-t-black" : "",
            loaderClassName
          )}
          role="status"
          aria-hidden="true"
        ></span>
        {message ? <p>{message}</p> : ""}
      </div>
    </div>
  ) : (
    ""
  );
  return <>{position === "portal" ? createPortal(loadingContent, document.body) : loadingContent}</>;
}
